import React from 'react';
import { Container } from './ui/Container';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsThisFor() {
  return <section className="py-20 bg-slate-950" data-id="element-198">
      <Container data-id="element-199">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-200">
          {/* For You */}
          <div data-id="element-201">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-202">
              <span className="bg-green-500/10 text-green-400 p-2 rounded-lg mr-3" data-id="element-203">
                <CheckCircleIcon className="w-6 h-6" data-id="element-204" />
              </span>
              Es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-205">
              {['Te despiertas entre 2–4AM y se te activa la mente', 'Odias sentir que tu día depende de tu noche', 'Quieres algo directo, sin vergüenza, sin teoría infinita', 'Te sirve lo imprimible y lo “paso a paso”'].map((item, i) => <li key={i} className="flex items-start text-slate-300" data-id="element-206">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 mr-3 mt-0.5 shrink-0" data-id="element-207" />
                  <span data-id="element-208">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div data-id="element-209">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-210">
              <span className="bg-red-500/10 text-red-400 p-2 rounded-lg mr-3" data-id="element-211">
                <XCircleIcon className="w-6 h-6" data-id="element-212" />
              </span>
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-213">
              {['Buscas tratamiento médico o promesas de curación', 'Quieres una explicación hormonal profunda (esto es práctico, no académico)', 'Buscas pastillas o suplementos', 'Prefieres usar apps o pantallas en la noche'].map((item, i) => <li key={i} className="flex items-start text-slate-300" data-id="element-214">
                  <XCircleIcon className="w-5 h-5 text-red-500 mr-3 mt-0.5 shrink-0" data-id="element-215" />
                  <span data-id="element-216">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </Container>
    </section>;
}